import Icon from '@cobliteam/ui/icons';

const GRADIENT = 'linear-gradient(135deg, #001BB8 0%, #9847EE 100%)';
const BORDER_GRADIENT = 'linear-gradient(90deg, #001BB8 0%, #9847EE 100%)';

const AiRecommendationTaskPopoverSkeleton = () => (
  <div className='p-3'>
    <div
      className='flex w-full flex-col items-center justify-center gap-4 rounded-xl py-12'
      style={{
        background: '#F8F7FD',
        border: '1px solid transparent',
        backgroundImage: `linear-gradient(#F8F7FD, #F8F7FD), ${BORDER_GRADIENT}`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        minHeight: '260px',
      }}
    >
      {/* Spinner */}
      <div className='relative flex h-14 w-14 shrink-0 items-center justify-center'>
        <div className='absolute inset-0 rounded-full' style={{ background: GRADIENT, opacity: 0.15, animation: 'pulseRing 2s ease-in-out infinite' }} />
        <svg className='absolute inset-0 animate-spin' viewBox='0 0 56 56' fill='none'>
          <circle cx='28' cy='28' r='22' stroke='#e5e7eb' strokeWidth='2.5' />
          <path d='M28 6 A22 22 0 0 1 50 28' stroke='url(#popoverSpinnerGrad)' strokeWidth='2.5' strokeLinecap='round' />
          <defs>
            <linearGradient id='popoverSpinnerGrad' x1='28' y1='6' x2='50' y2='28' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#001BB8' />
              <stop offset='1' stopColor='#9847EE' />
            </linearGradient>
          </defs>
        </svg>
        <div className='flex h-8 w-8 items-center justify-center rounded-lg' style={{ background: GRADIENT }}>
          <Icon name='sparkles' size='sm' className='text-white' />
        </div>
      </div>

      {/* Text */}
      <div className='flex flex-col items-center gap-1'>
        <span className='font-semibold text-base' style={{ background: GRADIENT, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          Analisando sua frota com IA
        </span>
        <span className='text-neutral-400 text-sm'>Isso pode levar alguns segundos...</span>
      </div>
    </div>
  </div>
);

export default AiRecommendationTaskPopoverSkeleton;
